import { get } from 'lodash';
import { pixelsToRem } from 'MoshtixShared/helper-pixels-to-rem';
import { configuration } from 'MoshtixShared/helper-responsive-configuration';

const mediumQuery = configuration.getMediaQuery('medium');

export const headerCss = ({ theme }) => ({
  textAlign: 'center',
  borderBottom: `1px solid ${get(theme, 'palette.border', '#e1e1e1')}`,
  backgroundColor: theme?.palette?.background || '#ffffff',
  paddingBottom: pixelsToRem(29),
  [mediumQuery]: {
    paddingBottom: pixelsToRem(37),
  },
});

export const logoContainerCss = {
  display: 'flex',
  justifyContent: 'center',
  marginTop: pixelsToRem(29),
  [mediumQuery]: {
    marginTop: pixelsToRem(37),
  },
};

export const logoCss = {
  height: pixelsToRem(32),
};
